import axios from "axios";
import addExtraInfoInterceptors from "@/utils/request/interceptors/addExtraInfo";
import addHostSignatureInterceptors from "@/utils/request/interceptors/addHostSignature";
import catchErrorInterceptors from "@/utils/request/interceptors/catchError";

const instance = axios.create({});

instance.interceptors.request.use(
  addExtraInfoInterceptors.onFulfilled,
  addExtraInfoInterceptors.onRejected
);

instance.interceptors.request.use(
  addHostSignatureInterceptors.onFulfilled,
  addHostSignatureInterceptors.onRejected
);

instance.interceptors.response.use(
  catchErrorInterceptors.onFulfilled,
  catchErrorInterceptors.onRejected
)

export default instance;
